/* MediGel PDP behaviour. Vanilla, dependency-free, resilient to missing sections.
   Replaces the design's ./support.js + ./image-slot.js. */
(function () {
  'use strict';
  if (window.__medigelInit) return;      // guard: init once even if included by several sections
  window.__medigelInit = true;
  var onReady = function (fn) {
    if (document.readyState !== 'loading') fn();
    else document.addEventListener('DOMContentLoaded', fn);
  };

  function money(cents) {
    var v = Math.round(cents) / 100;
    var whole = Math.round(v) === v;
    var s = whole ? String(v) : v.toFixed(2);
    // thousands separators
    var parts = s.split('.');
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return '$' + parts.join('.');
  }

  /* ---------------------------------------------------------------- Header */
  function initHeader(root) {
    var burger = root.querySelector('[data-medigel-burger]');
    var drawer = root.querySelector('[data-medigel-drawer]');
    if (burger && drawer) {
      burger.addEventListener('click', function () {
        var open = drawer.classList.toggle('is-open');
        burger.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    }
  }

  /* --------------------------------------------------------- Announcement */
  function initAnnounce(root) {
    var track = root.querySelector('[data-medigel-announce-track]');
    if (!track) return;
    var slides = track.children.length;
    if (slides < 2) return;
    var i = 0;
    setInterval(function () {
      if (window.innerWidth > 860) { track.style.transform = 'translateX(0)'; return; }
      i = (i + 1) % slides;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
    }, 3200);
  }

  /* ----------------------------------------------------------------- Hero */
  function initHero(hero) {
    var displays = document.querySelectorAll('[data-medigel-mirror]'); // hero main + sticky thumb
    var thumbs = hero.querySelectorAll('[data-medigel-thumb]');

    function selectThumb(idx) {
      thumbs.forEach(function (t, i) { t.classList.toggle('is-active', i === idx); });
      var img = thumbs[idx] && thumbs[idx].querySelector('img');
      if (!img) return;
      displays.forEach(function (d) {
        d.src = img.currentSrc || img.src;
        if (img.srcset) d.srcset = img.srcset;
        d.style.display = 'block';
      });
      var empty = document.querySelector('[data-medigel-hero-empty]');
      if (empty) empty.style.display = 'none';
    }
    thumbs.forEach(function (t, i) {
      t.addEventListener('click', function () { selectThumb(i); });
    });
    if (thumbs.length) selectThumb(0);

    /* Estimated delivery: ~2 business days to ship + ~7 days transit ------ */
    var deliverEls = hero.querySelectorAll('[data-medigel-deliver]');
    if (deliverEls.length) {
      var d = new Date();
      d.setDate(d.getDate() + 9);
      var label = d.toLocaleDateString(undefined, { weekday: 'short', month: 'short', day: 'numeric' });
      deliverEls.forEach(function (el) { el.textContent = label; });
    }

    /* Bundle tiers (visual) + cover + live total ------------------------- */
    var tiers = hero.querySelectorAll('[data-medigel-tier]');
    var coverBtn = hero.querySelector('[data-medigel-cover]');
    var totalEls = hero.querySelectorAll('[data-medigel-total]');
    var coverPriceEl = hero.querySelector('[data-medigel-cover-price]');
    var coverQtyEls = hero.querySelectorAll('[data-medigel-cover-qty]');
    var installmentEl = hero.querySelector('[data-medigel-installment]');
    var coverEach = parseInt(hero.dataset.coverEach || '0', 10); // cents
    var coverScales = hero.dataset.coverScales !== 'false';
    var initialTier = 0; // Liquid marks the default (2-pack) tier .is-active
    tiers.forEach(function (t, i) { if (t.classList.contains('is-active')) initialTier = i; });
    var state = { tier: initialTier, cover: coverBtn ? coverBtn.getAttribute('aria-pressed') === 'true' : false };

    function activeQty() {
      var t = tiers[state.tier];
      return t ? (parseInt(t.dataset.qty || '1', 10) || 1) : 1;
    }
    function render() {
      tiers.forEach(function (t, i) {
        t.classList.toggle('is-active', i === state.tier);
        t.setAttribute('aria-checked', i === state.tier ? 'true' : 'false');
      });
      var qty = activeQty();
      var coverQty = coverScales ? qty : 1;
      var tierTotal = tiers[state.tier] ? parseInt(tiers[state.tier].dataset.totalCents || '0', 10) : 0;
      var grand = tierTotal + (state.cover ? coverEach * coverQty : 0);
      totalEls.forEach(function (el) { el.textContent = money(grand); });
      if (coverBtn) {
        coverBtn.classList.toggle('is-on', state.cover);
        coverBtn.setAttribute('aria-pressed', state.cover ? 'true' : 'false');
      }
      if (coverPriceEl) coverPriceEl.textContent = '+' + money(coverEach * coverQty);
      coverQtyEls.forEach(function (el) { el.textContent = coverQty; });
      if (installmentEl) installmentEl.textContent = money(grand / 4);
    }
    tiers.forEach(function (t, i) {
      t.addEventListener('click', function () { state.tier = i; render(); });
      t.setAttribute('role', 'radio');
    });
    if (coverBtn) coverBtn.addEventListener('click', function () { state.cover = !state.cover; render(); });
    render();

    /* CTA: add base variant (+ real cover line item) then go to checkout - */
    var cta = hero.querySelector('[data-medigel-checkout]');
    if (cta) {
      cta.addEventListener('click', function () {
        var baseId = hero.dataset.baseVariant;
        if (!baseId) return;
        var qty = activeQty();
        var coverQty = coverScales ? qty : 1;
        var items = [{ id: Number(baseId), quantity: qty }];
        var coverId = hero.dataset.coverVariant;
        if (state.cover && coverId) items.push({ id: Number(coverId), quantity: coverQty });
        cta.setAttribute('aria-busy', 'true');
        fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: items })
        }).then(function (r) {
          if (!r.ok) throw new Error('add failed');
          window.location.href = '/checkout';
        }).catch(function () {
          // Fallback: cart permalink (adds items, lands on cart)
          var perma = items.map(function (it) { return it.id + ':' + it.quantity; }).join(',');
          window.location.href = '/cart/' + perma;
        });
      });
    }

    /* Scroll-to-buybox helpers (design "Select Bundle" buttons) ---------- */
    var buybox = hero.querySelector('[data-medigel-buybox]');
    document.querySelectorAll('[data-medigel-scroll-buy]').forEach(function (b) {
      b.addEventListener('click', function () {
        if (buybox) window.scrollTo({ top: window.scrollY + buybox.getBoundingClientRect().top - 40, behavior: 'smooth' });
      });
    });

    /* Featured review rotator ------------------------------------------- */
    var fr = hero.querySelector('[data-medigel-featured-review]');
    if (fr) {
      var slides = fr.querySelectorAll('[data-medigel-fr-slide]');
      if (slides.length > 1) {
        var idx = 0;
        setInterval(function () {
          slides[idx].style.opacity = '0';
          var prev = idx;
          idx = (idx + 1) % slides.length;
          setTimeout(function () {
            slides[prev].style.display = 'none';
            slides[idx].style.display = 'block';
            requestAnimationFrame(function () { slides[idx].style.opacity = '1'; });
          }, 320);
        }, 9000);
      }
    }

    /* Sticky bar reveal once the buybox is scrolled past ----------------- */
    var sticky = document.querySelector('[data-medigel-sticky]');
    if (sticky && buybox) {
      var onScroll = function () {
        var past = buybox.getBoundingClientRect().bottom < -40;
        sticky.classList.toggle('is-visible', past);
      };
      window.addEventListener('scroll', onScroll, { passive: true });
      onScroll();
    }
  }

  /* -------------------------------------------------------------- Reviews */
  function initReviews(root) {
    var chips = root.querySelectorAll('[data-medigel-chip]');
    var cards = root.querySelectorAll('[data-medigel-review]');
    var countEl = root.querySelector('[data-medigel-review-count]');
    var scroller = root.querySelector('[data-medigel-review-scroller]');

    function apply(cat) {
      var n = 0;
      cards.forEach(function (c) {
        var show = cat === 'all' || c.dataset.cat === cat;
        c.style.display = show ? '' : 'none';
        if (show) n++;
      });
      if (countEl) countEl.textContent = n;
      chips.forEach(function (ch) { ch.classList.toggle('is-active', ch.dataset.cat === cat); });
    }
    chips.forEach(function (ch) {
      ch.addEventListener('click', function () { apply(ch.dataset.cat || 'all'); });
    });
    if (chips.length) apply('all');

    var prev = root.querySelector('[data-medigel-review-prev]');
    var next = root.querySelector('[data-medigel-review-next]');
    var step = function (dir) { if (scroller) scroller.scrollBy({ left: dir * 372, behavior: 'smooth' }); };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });
  }

  /* ---------------------------------------------------------------- Video */
  function initVideo(root) {
    var scroller = root.querySelector('[data-medigel-video-scroller]');
    var prev = root.querySelector('[data-medigel-video-prev]');
    var next = root.querySelector('[data-medigel-video-next]');
    var stopped = false, paused = false;
    var step = function (dir) {
      stopped = true; // a manual click stops auto-cycling for good
      if (!scroller) return;
      var card = scroller.querySelector('.medigel-vcard');
      var w = card ? card.getBoundingClientRect().width + 20 : 300;
      scroller.scrollBy({ left: dir * w, behavior: 'smooth' });
    };
    if (prev) prev.addEventListener('click', function () { step(-1); });
    if (next) next.addEventListener('click', function () { step(1); });

    if (scroller && scroller.hasAttribute('data-medigel-video-autoscroll')
        && !window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      scroller.addEventListener('mouseenter', function () { paused = true; });
      scroller.addEventListener('mouseleave', function () { paused = false; });
      var last = null;
      var tick = function (t) {
        if (stopped) return;
        if (last != null && !paused) {
          scroller.scrollLeft += (t - last) * 0.032; // ~32px/s
          if (scroller.scrollLeft + scroller.clientWidth >= scroller.scrollWidth - 1) scroller.scrollLeft = 0;
        }
        last = t;
        requestAnimationFrame(tick);
      };
      requestAnimationFrame(tick);
    }

    root.querySelectorAll('[data-medigel-vplay]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var embed = btn.getAttribute('data-embed');
        if (!embed) return;
        var wrap = btn.closest('.medigel-vcard__inner');
        if (!wrap) return;
        wrap.innerHTML = '<iframe src="' + embed + '" title="Video" allow="autoplay; encrypted-media; fullscreen" allowfullscreen ' +
          'style="position:absolute;inset:0;width:100%;height:100%;border:0;"></iframe>';
      });
    });
  }

  onReady(function () {
    document.querySelectorAll('[data-medigel-header]').forEach(initHeader);
    document.querySelectorAll('[data-medigel-announce]').forEach(initAnnounce);
    document.querySelectorAll('[data-medigel-hero]').forEach(initHero);
    document.querySelectorAll('[data-medigel-reviews]').forEach(initReviews);
    document.querySelectorAll('[data-medigel-video]').forEach(initVideo);
  });
})();
